<div class="values-container">
    <table>
        <tr class="values-sub-container">
            <td class="status-label" title="Existing processes, Jobs and Tasks (in progress)">Processes:</td>
            <td class="status-label status-value" title="Existing processes, Jobs and Tasks (in progress)">
                {{processService.processesCount}}</td>
            <td class="status-label" title="The maximum number of threads allowed">Max Threads:</td>
            <td class="status-label status-value" title="The maximum number of threads allowed">
                {{processService.maxThreadsCount}}
            </td>
            <td class="status-label" title="The number of threads that can be started immediately">Ready Threads:</td>
            <td class="status-label status-value" title="The number of threads that can be started immediately">
                {{processService.allowedThreadsCount}}</td>
            <td class="status-label" title="Sum of max desired threads of running processes">Reserved Threads:</td>
            <td class="status-label status-value" title="Sum of max desired threads of running processes">
                {{processService.alreadyReservedThreadsCount}}</td>
            <td class="status-label used-capacity-cell" title="Threads used">Used:</td>
            <td class="status-label status-value" title="Threads used">{{processService.usedTreadsCapacity}}%
            </td>
            <td class="status-label" title="Threads scheduler status">
                <div>
                    <app-boolean-status [status]="processService.threadsIncreaseSchedulerActive"
                        title="Threads scheduler status" [label]="'Th Sh'"></app-boolean-status>
                </div>
            </td>
        </tr>
        <tr class="values-sub-container">
            <td class="status-label" title="Number of active processes">Active Processes:</td>
            <td class="status-label status-value" title="Number of active processes">
                {{processService.activeProcessesCount}}</td>
            <td class="status-label" title="The number of new threads that can be launched">Available Threads
            </td>
            <td class="status-label status-value" title="The number of new threads that can be launched">
                {{processService.availableToReserveThreadsCount}}</td>
            <td class="status-label" title="The number of threads that are currently running">Running Threads:</td>
            <td class="status-label status-value" title="The number of threads that are currently running">
                {{processService.runningThreadsCount}}</td>
            <td class="status-label" title="The time of the next increase in the number of threads">Next update:</td>
            <td class="status-label status-value" title="The time of the next increase in the number of threads"
                style="min-width: 60px;">
                {{processService.threadsUpdateTimeStr}}
            </td>
            <td colspan="2" title="Threads used" class="used-capacity-value">
                <mat-progress-bar class="used-capacity-progress" mode="determinate"
                    value="{{processService.usedTreadsCapacity}}" color="accent">
                </mat-progress-bar>
            </td>
            <td class="status-label" title="Processes scheduler status">
                <div style="display: flex;">
                    <app-boolean-status [status]="processService.processesSchedulerActive"
                        title="Process scheduler status" [label]="'Pr Sh'"></app-boolean-status>
                </div>
            </td>
        </tr>
    </table>
</div>